import _ from 'lodash';
import Papa from 'papaparse';

export function formatToCsv({ data: rows, returnBlob }) {
  // we are doing this because certain keys are objects/array which papa parse doesn't stringify
  const mappedRows = _.map(rows, (row) =>
    _.mapValues(row, (value) =>
      _.isObject(value) || _.isArray(value) ? JSON.stringify(value) : value
    )
  );

  let uniqueKeys = {};
  rows.forEach((event) => {
    uniqueKeys = { ...event, ...uniqueKeys };
  });

  // https://www.papaparse.com/docs#config
  const unparseFormat = {
    fields: Object.keys(uniqueKeys),
    data: mappedRows
  };

  const csvData = Papa.unparse(unparseFormat, { escapeFormulae: true });

  return returnBlob
    ? new Blob([csvData], { type: 'text/csv' })
    : `data:text/csv;charset=utf-8,${encodeURIComponent(csvData)}`;
}

/**
 * Download a file from a blob
 * @param {Object} params - Download parameters
 * @param {string} params.name - File name
 * @param {Blob} params.url - File blob
 */
export function download({ name, url }) {
  const objectURL = URL.createObjectURL(url);
  return downloadFromUrl({
    name,
    url: objectURL,
    onFinish: () => URL.revokeObjectURL(objectURL)
  });
}

/**
 * Download a file from a URL
 * @param {Object} params - Download parameters
 * @param {string} params.name - File name
 * @param {string} params.url - File URL
 * @param {Function} [params.onFinish] - Callback function to be called when the download is complete
 */
export function downloadFromUrl({ name, url, onFinish }) {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);

  // Firefox requires the link be added to the DOM before it can be .click()'d
  document.body.appendChild(link);
  link.click();
  // Need to make sure we wait for the next event loop to be sure the link click finishes
  // before we remove the link from the DOM and revoke the object URL
  setTimeout(() => {
    document.body.removeChild(link);
    if (typeof onFinish === 'function') {
      onFinish();
    }
  }, 0);
}
